import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { HelmetProvider } from "react-helmet-async";
import { msalConfig } from "./authConfig";
import { runAuthStartupMaintenance } from "./utils/authRecovery";

console.log('[Index] Starting MSAL initialization');

runAuthStartupMaintenance();

const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL and render the app
// MsalProvider will automatically call handleRedirectPromise() for us
msalInstance.initialize().then(() => {
  console.log('[Index] MSAL initialized');
  
  // Store instance globally for debugging
  window.__msalInstance = msalInstance;
  
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <ErrorBoundary>
      <HelmetProvider>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}).catch(error => {
  console.error('[Index] MSAL initialization failed:', error);
  
  // Still render the app even if initialization fails
  window.__msalInstance = msalInstance;
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <ErrorBoundary>
      <HelmetProvider>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
});